import React, { useState, useEffect } from "react";

const ConnectTab = ({ updateChatTabData, chatTabData }) => {
    const [instagramUsername, setInstagramUsername] = useState("");

    useEffect(() => {
        if (chatTabData?.instagram_username) {
            setInstagramUsername(chatTabData.instagram_username);
        }
    }, [chatTabData?.instagram_username]);

    const handleInputChange = (event) => {
        const value = event.target.value;
        setInstagramUsername(value);
        updateChatTabData("instagram_username", value);
    };

    return (
        <div className="whats-app-side-baar-connect-tab">
            <span>Connect</span>
            <div className="source-serach-baar">
                <div className="google-search-container">
                    <input
                        type="text"
                        value={instagramUsername}
                        onChange={handleInputChange}
                        placeholder="Instagram Username"
                    />
                </div>
            </div>
            <p>Example: upgadeify_people </p>
        </div>
    );
};

export default ConnectTab;